var map = {
	"./Dashboard.tsx": 489,
	"./Declare.tsx": 487,
	"./Edumain.tsx": 468,
	"./Eduresult.tsx": 485,
	"./Exam.tsx": 486,
	"./Faq.tsx": 469,
	"./Intro.tsx": 470,
	"./Login.tsx": 471,
	"./Mudlogin.tsx": 472,
	"./Mudmanage.tsx": 474,
	"./Mypage.tsx": 475,
	"./Target.tsx": 488,
	"./Template.tsx": 482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1010;